<form>
  <mat-dialog-content class="!grid">
    <p class="dialog-title">Quitar</p>
    <hr class="dialog-divider" />
    <mat-form-field class="!w-full !mt-3">
      <mat-label>Ingrese la justificación para quitar este tema</mat-label>
      <mat-select name="justificacion" [formControl]="justificacion">
        @for (item of catJustificacion; track item) {
        <mat-option [value]="item.descripcion">{{ item.descripcion }}</mat-option>
        }
      </mat-select>
      @if(justificacion.hasError('required')&&justificacion.touched) {
      <mat-error>Campo obligatorio</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions class="!justify-end">
    <button
      class="uppercase-button"
      mat-raised-button
      [mat-dialog-close]="false">
      CANCELAR
    </button>
    <button
      mat-flat-button
      [color]="'primary'"
      [disabled]="justificacion.invalid"
      (click)="save()">
      ACEPTAR
    </button>
  </mat-dialog-actions>
</form>
